
import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';

export const ProductDetailSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow pt-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="animate-pulse">
            <div className="h-6 bg-gray-200 rounded w-3/4 mb-6"></div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <div className="bg-gray-200 rounded-lg aspect-[4/3] mb-2"></div>
                <div className="grid grid-cols-4 gap-2">
                  {Array(4).fill(0).map((_, i) => (
                    <div key={i} className="bg-gray-200 rounded-md h-16"></div>
                  ))}
                </div>
              </div>
              <div>
                <div className="bg-gray-200 rounded-lg h-96"></div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
